export var entriesDropdownList = [
    { title: "1", value: "1" },
    { title: "2", value: "2" },
    { title: "3", value: "3" },
    { title: "4", value: "4" },
    { title: "5", value: "5" },
    { title: "6", value: "6" },
    { title: "7", value: "7" },
    { title: "8", value: "8" },
    { title: "9", value: "9" },
    { title: "10", value: "10" },
];
export var quotesCreatedColumn = [
    { name: "Quote ID", key: "quote_id" },
    {
        name: "Created Date",
        key: "created_date",
    },
    {
        name: "Policy Holder Name",
        key: "policy_holder_name",
    },
    {
        name: "Product Name",
        key: "product_name",
    },
    {
        name: "Plan Name",
        key: "plan_name",
    },
    {
        name: "Policy Type",
        key: "policy_type",
    },
    {
        name: "Gross Premium",
        key: "gross_premium",
        columnClass: "text-end",
    },
    {
        name: "Sum Insured",
        key: "sum_insured",
        columnClass: "text-end",
    },
    {
        name: "Status",
        key: "status",
    },
    {
        name: "Last Updated Date",
        key: "last_updated_date",
    },
    {
        name: "Source",
        key: "source",
    },
    {
        name: "Action",
        key: "action",
    },
];
export var quotesData = [
    {
        quote_id: "98765436",
        created_date: "2022-01-15",
        policy_holder_name: "John Doe",
        product_name: "Insurance Product A",
        plan_name: "Basic Plan",
        policy_type: "Life Insurance",
        gross_premium: "$1000",
        sum_insured: "$50000",
        status: "Active",
        last_updated_date: "2022-01-20",
        source: "Online",
        action: "View",
    },
    {
        quote_id: "46789098",
        created_date: "2022-02-01",
        policy_holder_name: "Jane Smith",
        product_name: "Insurance Product B",
        plan_name: "Premium Plan",
        policy_type: "Health Insurance",
        gross_premium: "$1500",
        sum_insured: "$75000",
        status: "Expired",
        last_updated_date: "2022-02-10",
        source: "Agent",
        action: "Edit",
    },
];
export var preInsuranceColumn = [
    { name: "Payment Submitted", key: "payment_submitted" },
    { name: "Proposal Submitted", key: "proposal_submitted" },
    { name: "Customer Authentication", key: "customer_authentication" },
    { name: "Referred to UW", key: "referred_to_uw" },
];
export var preInsuranceData = [
    {
        payment_submitted: "-",
        proposal_submitted: "-",
        customer_authentication: "-",
        referred_to_uw: "-",
    },
    {
        payment_submitted: "-",
        proposal_submitted: "-",
        customer_authentication: "-",
        referred_to_uw: "-",
    },
];
export var renewalsColumn = [
    { name: "Policy Number", key: "policy_number" },
    { name: "Policy Holder Name", key: "policy_holder_name" },
    { name: "Policy Issuance Date", key: "policy_issuance_date" },
    { name: "Policy Type", key: "policy_type" },
    { name: "Product Name", key: "product_name" },
    { name: "Plan Name", key: "plan_name" },
    { name: "Sum Insured", key: "sum_insured", columnClass: "text-end" },
    {
        name: "Days Till Renewal",
        key: "days_till_renewal",
        columnClass: "text-end",
    },
    { name: "Renewal Date", key: "renewal_date" },
];
export var renewalsData = [
    {
        policy_number: "98763546",
        policy_holder_name: "Sarvesh S Jha",
        policy_issuance_date: "21-Sept-23",
        policy_type: "Life Insurance",
        product_name: "Wealth Plus",
        plan_name: "Edelweiss Tokio Life - Wealth Plus",
        sum_insured: "35,00,000",
        days_till_renewal: "28",
        renewal_date: "17-Nov-23",
    },
    {
        policy_number: "98763546",
        policy_holder_name: "Sarvesh S Jha",
        policy_issuance_date: "21-Sept-23",
        policy_type: "Life Insurance",
        product_name: "Wealth Plus",
        plan_name: "Edelweiss Tokio Life - Wealth Plus",
        sum_insured: "35,00,000",
        days_till_renewal: "28",
        renewal_date: "17-Nov-23",
    },
];
export var dpBillsActivityColumn = [
    { name: "PAN No", key: "pan_no" },
    { name: "Client Name", key: "client_name" },
    { name: "Partner Code", key: "partner_code", columnClass: "text-end" },
    { name: "Partner Name", key: "partner_name" },
    { name: "DP ID", key: "dp_id", columnClass: "text-end" },
    { name: "Amount", key: "amount", columnClass: "text-end" },
    { name: "Narration", key: "narration" },
    { name: "Demat Status", key: "demat_status" },
    { name: "POA in Favour of (ECL/EBL/ESL)", key: "poa_in_favour" },
    { name: "Bank Name", key: "bank_name" },
    {
        name: "Bank Account Number",
        key: "bank_account_number",
        columnClass: "text-end",
    },
];
export var dpBillsData = [
    {
        pan_no: "ACOPM3888L",
        client_name: "Namdeo L Mulik",
        partner_code: "1455",
        partner_name: "Nikhil Bhanushali",
        dp_id: "1203230000020142",
        amount: "500",
        narration: "I-%REGULAR SCH POA",
        demat_status: "Active",
        poa_in_favour: "CDSL ESL",
        bank_name: "STATE BANK OF INDIA",
        bank_account_number: "01190024803",
    },
    {
        pan_no: "ACOPM3888L",
        client_name: "Namdeo L Mulik",
        partner_code: "1455",
        partner_name: "Nikhil Bhanushali",
        dp_id: "1203230000020142",
        amount: "500",
        narration: "I-%REGULAR SCH POA",
        demat_status: "Active",
        poa_in_favour: "CDSL ESL",
        bank_name: "STATE BANK OF INDIA",
        bank_account_number: "01190024803",
    },
];
export var GWMRiskData = [
    {
        code: "98765436",
        family: "10-Aug-23",
        name: "Manoj s Sharma",
        shortfall_excess: "1,87,678",
        gross_ledger: "22,87,678",
        gross_collateral: "13,87,678",
        gross_collateral_post_hc_cap: "22,87,678",
        span_margin: "1,87,678",
        exposure_margin: "1,87,789",
        delivery_margin: "1,89,900",
        fno_exposure: "1,23,212",
        short_option: "-",
        long_option: "-",
        gnlv: "-",
        gnlv_per: "30%",
        broking_pledge_stock: "-",
        nbfc_pledge_stock: "-",
        broking_ledger: "11,87,678",
        secured_loan: "22,87,678",
        unsecured_loan: "22,87,678",
        nbfc_loan: "1,42,332",
        fd: "1,23,232",
        uncleared_chq: "-",
        tpc: "-",
        net_ledger: "32,32,322",
        smtf_ledger: "22,43,532",
        mfss_ledger: "32,32,453",
        poa_cash_margin: "32,32,231",
        other_holdings: "11,44,242",
        gross_collateral_post_hc: "21,63,323",
        gross_collateral_post_var: "1,78,722",
        cds_margin: "1,78,289",
        po_short: "1,43,234",
        mfss_purchase_redemption: "1,22,321",
        payin_shortages: "22,22,134",
        btst_stock: "-",
        sponsored_limit: "22,42,122",
        pan: "APLPM2345H",
        empl_tagging: "-",
        las_tagging: "-",
        broking_pledge_post_var: "-",
        servicing_rm: "Rishi S Mane",
        cluster: "-",
    },
    {
        code: "98765436",
        family: "10-Aug-23",
        name: "Manoj s Sharma",
        shortfall_excess: "1,87,678",
        gross_ledger: "22,87,678",
        gross_collateral: "13,87,678",
        gross_collateral_post_hc_cap: "22,87,678",
        span_margin: "1,87,678",
        exposure_margin: "1,87,789",
        delivery_margin: "1,89,900",
        fno_exposure: "1,23,212",
        short_option: "-",
        long_option: "-",
        gnlv: "-",
        gnlv_per: "30%",
        broking_pledge_stock: "-",
        nbfc_pledge_stock: "-",
        broking_ledger: "11,87,678",
        secured_loan: "22,87,678",
        unsecured_loan: "22,87,678",
        nbfc_loan: "1,42,332",
        fd: "1,23,232",
        uncleared_chq: "-",
        tpc: "-",
        net_ledger: "32,32,322",
        smtf_ledger: "22,43,532",
        mfss_ledger: "32,32,453",
        poa_cash_margin: "32,32,231",
        other_holdings: "11,44,242",
        gross_collateral_post_hc: "21,63,323",
        gross_collateral_post_var: "1,78,722",
        cds_margin: "1,78,289",
        po_short: "1,43,234",
        mfss_purchase_redemption: "1,22,321",
        payin_shortages: "22,22,134",
        btst_stock: "-",
        sponsored_limit: "22,42,122",
        pan: "APLPM2345H",
        empl_tagging: "-",
        las_tagging: "-",
        broking_pledge_post_var: "-",
        servicing_rm: "Rishi S Mane",
        cluster: "-",
    },
];
export var dummytableData = [
    {
        "pan no": "ACOPM3888Lb",
        "client name": "Namdeo L Mulik",
        "partner code": "1455",
        partner_name: "Nikhil Bhanushali",
        "dp id": "1203230000020142",
        amount: "500",
        narration: "I-%REGULAR SCH POA",
        demat_status: "Active",
        poa_in_favour: "CDSL ESL",
        bank_name: "STATE BANK OF INDIA",
        bank_account_number: "01190024803",
    },
    {
        "pan no": "ACOPM3888L",
        "client name": "Namdeo La Mulik",
        "partner code": "1455",
        partner_name: "Nikhil Bhanushalii",
        "dp id": "1203230000020142",
        amount: "500",
        narration: "I-%REGULAR SCH POA",
        demat_status: "Activa",
        poa_in_favour: "CDSL ESL",
        bank_name: "STATE BANK OF Country",
        bank_account_number: "01190024803",
    },
];
